import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { SHr, SPage, SText, SView, STheme, SImage, SLoad } from 'servisofts-component2';
import { WebView } from 'react-native';
import SSocket from 'servisofts-socket';
// import Model from '../../Model';
import AccentBar from '../../Components/AccentBar';
import MDL from '../../MDL';
// import SIconApp from '../../Assets/SIconApp';
import ILlamar from "../../Assets/svg/illamar.svg";
import EmailIcon from "../../Assets/svg/registro/emailIcon.svg";


export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.callback = MDL.usuario.addEventListener("changeSessionStatus", (e) => {
      this.setState({ ...this.state });
    })
  }
  componentWillUnmount() {
    MDL.usuario.removeEventListener(this.callback)
  }
  load_data() {
    // this.data = Model.direccion_usuario.Action.getAll();
    // this.data = Model.usuario.Action.getUsuarioLog();
    this.data = MDL.usuario.session;

    return this.data;
  }

  getPerfil() {

    if (!this.load_data()) return <SLoad />
    var usuario = this.data;
    // var usuario = this.props.state.usuarioReducer.usuarioLog;
    // if (!usuario) {
    //     SNavigation.navigate('login');
    //     return <SView />
    // }

    // var usuario = Model.usuario.Action.getUsuarioLog();
    // if (!usuario) return <SView col={"xs-12"} center height onPress={() => {
    // 	SNavigation.navigate("/login")
    // 	this.fadeOut();
    // }}></SView>
    return (
      <SView center>
        <SView style={{
          width: 140,
          height: 140,
          justifyContent: "center",
          alignItems: "center"
        }}>
          <SView style={{
            position: "absolute"
          }}>
            {/* <SIcon name='InputUser' width={139} height={139} /> */}
          </SView>

          <SView style={{
            width: "100%",
            height: "100%",
            backgroundColor: STheme.color.card,
            borderRadius: 100,
            overflow: "hidden",
          }} border={STheme.color.lightGray}>
            <SImage src={SSocket.api.root + "usuario/" + usuario?.key + "?date=" + new Date().getTime()}

              style={{ resizeMode: 'cover', }} />


          </SView>
        </SView>
        <SHr />
        <SView >
          <SView center>
            <SText style={{
              // flex: 5,
              fontSize: 18,
              // fontWeight: "bold",
              // color: "#fff"
            }}>{usuario?.sNombreChofer} </SText>
          </SView>
          <SHr />


        </SView>
      </SView>
    )
  }
  getDato(key, icon) {
    // var text = usuario_dato
    if (!this.data) return null;
    var text = this.data[key] ?? '--';
    if (key == "Password") {
      text = "************"
    }
    return <SView row col={"xs-12"} center padding={8} card>
      {/* <SIconApp name={icon} width={40} height={30}  fill={STheme.color.text}/> */}
      {icon}
      <SView width={16} />
      <SText>{text}</SText>
      <SView flex />
    </SView>
  }
  getDatos() {
    return <SView col={"xs-12"} center>
      {/* {this.getDato("Nombres", "InputUser")} */}
      {/* {this.getDato("Apellidos", "InputUser")} */}
      {/* {this.getDato("CI", "InputUser")} */}
      {/* {this.getDato("Fecha de nacimiento", "Calendar")} */}
      {this.getDato("sTelefono", <ILlamar width={40} height={30} fill={STheme.color.text} />)}
      <SHr h={15} />
      {this.getDato("sMail", <EmailIcon width={40} height={30} fill={STheme.color.text} />)}
      {/* {this.getDato("Password", "InputPassword")} */}
      {/* {this.getDato("Direccion", "InputLocation")} */}

    </SView>
  }

  render() {
    return (<SPage footer={<AccentBar type='3' />} title={'Editar perfil'} onRefresh={(callback) => {
      // Model.usuario.Action.CLEAR();
      // Model.usuario.Action.syncUserLog*
      // console.log

    }}
    >
      <SHr h={60} />
      <SView col={"xs-12"} center>
        <SView col={"xs-11 sm-10 md-8 lg-6 xl-4"} center>
          {/* <SView height={80}></SView> */}
          <SHr height={10} />
          {this.getPerfil()}
          {this.getDatos()}
          <SView height={50}></SView>

          {/* <PButtom fontSize={20} onPress={() => {
                        SNavigation.navigate("/perfil/editar", { key: this.data.key });
                    }}>EDITAR</PButtom>
                    <SHr height={10} />
                    <PButtom fontSize={20} onPress={() => {
                        SPopup.confirm({
                            title: "Eliminar cuenta", message: "¿Estás seguro de eliminar la cuenta?", onPress: () => {
                                Model.usuario.Action.editar({
                                    data: {
                                        ...this.data,
                                        estado: 0
                                    },
                                }
                                );
                                Model.usuario.Action.CLEAR() //Limpiar caché
                                Model.usuario.Action.unlogin();
                            }
                        })
                    }}>ELIMINAR CUENTA</PButtom>
                    <SView height={30}></SView> */}
        </SView>
      </SView>
    </SPage>
    );
  }
}
